export default {
    normalText: {
        fontFamily: 'Lato',
    },
    boldText: {
        fontFamily: 'Lato',
        fontWeight: '700'
    }
}
